import { Box, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { rem } from 'polished';

import { NextStepProps } from './SWConfigureBundleOptions.types';

export const HeadingWrapper = styled(Flex)``;

export const ButtonsWrapper = styled(Flex)`
  [class*='Buttonstyle__Button-sc'],
  [class*='ButtonWithIconstyle__ButtonWithIcon-sc'] {
    background: transparent;
    border: ${rem('1px')} solid;
    border-color: #f4f4f4;
    color: #f4f4f4;
    font-size: ${rem('20px')};
    min-width: auto;
    width: ${rem('50px')};
    height: ${rem('50px')};

    &:hover {
      border: ${rem('1px')} solid;

      [class*='Iconstyle__Icon'] * {
        stroke: #f4f4f4;
      }
    }

    @media only screen and (min-width: ${rem('1441px')}) {
      width: ${rem('180px')};
    }

    [class*='Iconstyle__Icon'] {
      margin-right: 0;

      @media only screen and (min-width: ${rem('768px')}) {
        margin-right: ${rem('4px')};
      }

      svg {
        stroke: #f4f4f4;
        width: ${rem('20px')};
        height: ${rem('20px')};
      }
    }
  }
`;

export const CancelButton = styled(ButtonsWrapper)`
  [class*='Buttonstyle__Button-sc'],
  [class*='ButtonWithIconstyle__ButtonWithIcon-sc'] {
    @media only screen and (max-width: ${rem('1440px')}) {
      font-size: 0;
    }
  }
`;

export const NextButton = styled(ButtonsWrapper)<Pick<NextStepProps, 'isEnabled'>>`
  [class*='Buttonstyle__Button-sc'],
  [class*='ButtonWithIconstyle__ButtonWithIcon-sc'] {
    background: ${({ isEnabled, theme }) => (isEnabled ? theme.color.primary1.default : '#bdbbbb')};
    border-color: ${({ isEnabled, theme }) => (isEnabled ? theme.color.primary1.default : '#bdbbbb')};
    color: ${({ theme }) => theme.color.monochrome1.default};
    width: ${rem('345px')};

    @media only screen and (min-width: ${rem('992px')}) {
      width: ${rem('380px')};
    }
  }
`;

export const RadioWrapper = styled(Box)`
  [class*='Radiostyle__RadioWrapper-sc'] {
    padding: 0;
    position: static;
  }

  [class*='Radiostyle__LabelText-sc'] {
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;

    &:before,
    &:after {
      left: auto;
      top: auto;
      transform: none;
    }
    &:before {
      background: transparent;
    }
  }
`;
